import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9c53bcb0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "paymentMethod" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-warpit_icon_kreditna" }, null, -1))
const _hoisted_5 = ["disabled"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 80 80",
  class: "flik mr-2"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    r: "37",
    cx: "40",
    cy: "40",
    fill: "white"
  }),
  /*#__PURE__*/_createElementVNode("path", { d: "M45 30.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0zM57 48h2V29h-2v19zm11 0h-2.616L60 41.463 65.044 35h2.609l-5.189 6.448L68 48zm-19.49-1.82H53V48H42v-1.82h4.251v-9.36H42.4V35h6.11v11.18zm-15.001-.014H38V48H27v-1.834h4.251V30.834h-3.985V29h6.243v17.166zM20.765 29c.744 0 1.36.078 2.235.26v1.958c-.565-.079-1.26-.208-2.235-.208-1.954 0-2.649.678-2.649 2.662v1.278H23v1.8h-4.884v2.095H23v1.801h-4.884V48h-2.183v-7.354H12v-1.8h3.933V36.75H12v-1.8h3.933v-1.435c0-2.975 1.644-4.515 4.832-4.515zm19.234 49C19.046 78 2 60.954 2 40S19.046 2 40 2c20.953 0 38 17.046 38 38S60.953 78 40 78zM40 0C17.91 0 0 17.909 0 40c0 22.092 17.909 40 40 40s40-17.908 40-40C80 17.91 62.091 0 40 0z" })
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "gray" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-warpit_icon_zoom_in" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "gray" }, null, -1))
const _hoisted_10 = ["disabled"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-warpit_icon_arrow-R" }, null, -1))
const _hoisted_12 = {
  key: 0,
  class: "paymentValue"
}
const _hoisted_13 = { class: "black" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.invoice)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("p", null, _toDisplayString(_ctx.$t("payments.way_of_payment")), 1),
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paymentMethods, (paymentMethod, index) => {
            return (_openBlock(), _createElementBlock("button", {
              key: index,
              class: _normalizeClass(["defaultButton whiteBG left", {
          selected:
            _ctx.selectedCard === paymentMethod && _ctx.selectedPaymentMethod === 'card',
        }]),
              onClick: ($event: any) => {
          _ctx.selectedPaymentMethod = 'card';
          _ctx.selectedCard = paymentMethod;
        }
            }, [
              _hoisted_4,
              _createTextVNode(_toDisplayString(paymentMethod.custom_name), 1)
            ], 10, _hoisted_3))
          }), 128)),
          (_ctx.flikEnabled)
            ? _withDirectives((_openBlock(), _createElementBlock("button", {
                key: 0,
                class: _normalizeClass(["defaultButton whiteBG left", { selected: _ctx.selectedPaymentMethod === 'flik' }]),
                disabled: _ctx.invoice.amount > 150000000,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectedPaymentMethod = 'flik'))
              }, [
                _hoisted_6,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("payments.flik")), 1)
              ], 10, _hoisted_5)), [
                [
                  _directive_tooltip,
                  {
          value: _ctx.$t('payments.flik_max'),
          disabled: _ctx.invoice.amount < 150000000,
        },
                  void 0,
                  { top: true }
                ]
              ])
            : _createCommentVNode("", true),
          _hoisted_7,
          _createElementVNode("button", {
            class: _normalizeClass(["defaultButton whiteBG left", {
          selected: _ctx.selectedCard === null && _ctx.selectedPaymentMethod === 'card',
        }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => {
          _ctx.selectedCard = null;
          _ctx.selectedPaymentMethod = 'card';
        })
          }, [
            _hoisted_8,
            _createTextVNode(_toDisplayString(_ctx.$t("payments.add_new_card")), 1)
          ], 2),
          _hoisted_9,
          _createElementVNode("button", {
            "event-name": "nextSuppliersPaymentButton",
            "event-from": "/user/my-payments/invoices/*/payment",
            class: "defaultButton next",
            disabled: _ctx.selectedPaymentMethod === null,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('submit', _ctx.selectedPaymentMethod, _ctx.selectedCard)))
          }, [
            _createTextVNode(_toDisplayString(_ctx.$t("payments.forward")), 1),
            _hoisted_11
          ], 8, _hoisted_10),
          _createVNode(_component_router_link, {
            to: { name: 'PaymentOpen' },
            class: "cancel"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("payments.decline_pay")), 1)
            ]),
            _: 1
          })
        ]),
        (_ctx.invoice)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("span", null, [
                _createTextVNode(_toDisplayString(_ctx.$t("payments.value_of_purchase")) + ": ", 1),
                _createElementVNode("span", _hoisted_13, _toDisplayString((_ctx.invoice.amount / 10000).toLocaleString(_ctx.$i18n.locale, {
              maximumFractionDigits: 2,
            })) + " " + _toDisplayString(_ctx.invoice.currency), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}